import { property as p } from "lit/decorators.js";
import { SpectrumElement as u } from "@spectrum-web-components/core/shared/base/index.js";
import { ASSET_VARIANTS as l } from "./Asset.types.js";
var d = Object.defineProperty, c = (o, r, e, s) => {
  for (var t = void 0, n = o.length - 1, a; n >= 0; n--)
    (a = o[n]) && (t = a(r, e, t) || t);
  return t && d(r, e, t), t;
};
class i extends u {
  constructor() {
    super(...arguments), this.label = "";
  }
  // ──────────────────────
  //     IMPLEMENTATION
  // ──────────────────────
  updated(r) {
    var e;
    if (super.updated(r), (e = window.__swc) != null && e.DEBUG) {
      const s = this.constructor;
      typeof this.variant != "undefined" && !s.VARIANTS.includes(this.variant) && window.__swc.warn(
        this,
        `<${this.localName}> element expects the "variant" attribute to be one of the following:`,
        "https://opensource.adobe.com/spectrum-web-components/components/asset/",
        {
          issues: [...s.VARIANTS]
        }
      );
    }
  }
}
i.VARIANTS = l;
c([
  p({ type: String, reflect: !0 })
], i.prototype, "variant");
c([
  p()
], i.prototype, "label");
export {
  i as AssetBase
};
//# sourceMappingURL=Asset.base.js.map
